import {debounce} from 'throttle-debounce';

import initHomeScrollAnim from './home-scroll-anim';
import initMarqueesSection from './marquees-section';

import { isHomePage, IS_TOUCH, DOM } from '../../helpers/consts';
import refreshScrollAndTriggers from '../../helpers/refreshScrollTriggers';
import initServiceModals from './service-modals';

export default () => {
	if(!isHomePage) return;

	DOM.header.classList.add('is-blue');

	initHomeScrollAnim();
	initMarqueesSection();
	initServiceModals();


	const resize = () => {
		refreshScrollAndTriggers();
	};

	if (IS_TOUCH) {
		window.addEventListener('orientationchange', debounce(450, resize));
	}
	else {
		window.addEventListener('resize', debounce(300, resize));
	}

};

